<div>
  <div *ngFor="let categoryItem of field.selectedItems">
    {{ categoryItem }}
  </div>
</div>
